import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DatiqButtonSizes, DatiqButtonTypes, IDatiqButton, emptyDatiqButton } from '../../models';
import { DatiqButtonEventsService } from '../../services';

@Component({
    selector: 'datiq-button',
    templateUrl: './datiq-button.component.html',
    styleUrls: ['./datiq-button.component.scss'],
})
export class DatiqButtonComponent {
    private _settings: IDatiqButton;

    disabled: boolean;
    primary: boolean;
    secondary: boolean;
    tertiary: boolean;
    danger: boolean;
    dangerGhost: boolean;
    condensed: boolean;

    @Output()
    clicked: EventEmitter<IDatiqButton> = new EventEmitter<IDatiqButton>();

    @Input()
    get settings(): IDatiqButton {
        return this._settings;
    }
    set settings(value: IDatiqButton) {
        this.updateButton(value);
    }

    constructor(private _events: DatiqButtonEventsService) {}

    updateButton(
        settings: IDatiqButton = { ...emptyDatiqButton }
    ): IDatiqButton {
        this._settings = settings;
        this.disabled = !!settings?.disabled;
        this.primary = settings.type === DatiqButtonTypes.Primary;
        this.secondary = settings.type === DatiqButtonTypes.Secondary;
        this.tertiary = settings.type === DatiqButtonTypes.Tertiary;
        this.danger = settings.type === DatiqButtonTypes.Danger;
        this.dangerGhost = settings.type === DatiqButtonTypes.DangerGhost;
        this.condensed = settings.size === DatiqButtonSizes.Condensed;

        return this._settings;
    }

    click(): void {
        this._events.click(this.settings);
        this.clicked.emit(this.settings);
    }
}
